function setSameHeight() {
  const gridItems = document.querySelectorAll('[data-grid-item]');
  const heights = Array.from(gridItems).map((e) => e.offsetHeight);
  const maxheight = Math.max(...heights);
  gridItems.forEach((e) => (e.style.height = maxheight + 'px'));
}

export function init() {
  setSameHeight();
}
